import { useQuery, UseQueryOptions } from "react-query";
import { Route } from "@edgetier/watchtower-types";
import { AxiosError } from "axios";
import { axios } from "utilities/axios";

/**
 * Request the access token from the backend.
 * @param url             The URL for the request.
 * @param queryParameters Any query parameters to be send with the request.
 * @returns An access token that can be used to request the metabase dashboard.
 */
const requestMetabaseToken = async (url: string, queryParameters: {}) => {
    const { data } = await axios.post(url, { params: queryParameters });
    return data.accessToken;
};

/**
 * A query to get a metabase token from the backend.
 * @param dashboardId     The ID of the dashboard that the user wants to view.
 * @param queryParameters Any query parameters to be send with the request.
 * @param options         Any react query options to be used with the query.
 */
const useMetabaseToken = <T = string>(
    metabaseDashboardId: string,
    queryParameters: {} = {},
    options: Omit<UseQueryOptions<string[], AxiosError, T>, "queryKey" | "queryFn"> = {}
) => {
    const url = Route.MetabaseTokens.replace(":metabaseDashboardId", metabaseDashboardId);
    return useQuery<string[], AxiosError, T>(
        [url, queryParameters],
        () => requestMetabaseToken(url, queryParameters),
        options
    );
};

export default useMetabaseToken;
